import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { InstanceInterface } from '../models/instance.interface';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {
  constructor(private readonly apollo: Apollo) { }

  getInstances(seriePublicId: string): Observable<InstanceInterface[]> {
    return this.apollo.query<{ instances: InstanceInterface[] }>({
      query : gql`query instances($seriePublicId: String!) {
        instances(seriePublicId: $seriePublicId) {
          internalid
          publicid
        }
      }`,
      variables: { seriePublicId }
    }).pipe(map(res => res.data.instances));
  }
}
